import { stepDefById, isValidDateArrives } from "../catalog";

let stepSeq = 0;
export const genId = () => {
  stepSeq += 1;
  return `s_${Date.now().toString(36)}_${stepSeq}`;
};

// A step's message is empty for a channel if neither its per-channel version
// nor the legacy single config.message has anything in it — same fallback
// order the server's templateFor (channelDelivery.js) uses.
export const messageFor = (config, channel) => {
  const messages = config.messages || {};
  const fallback = config.message || "";
  if (channel === "SMS") return String(messages.sms ?? fallback).trim();
  if (channel === "In-app") return String(messages.inapp ?? fallback).trim();
  return String(messages.email?.body ?? fallback).trim();
};

// Everything that would silently no-op or reject on save, surfaced up front
// instead of a disabled Save button with no explanation. Each issue targets
// a card (trigger or step id) + field so the canvas and setup panel can both
// point at exactly what needs fixing.
export const validateDraft = (draft) => {
  const issues = [];
  if (draft.trigger) {
    const config = draft.trigger.config || {};
    const { type } = draft.trigger;
    const needsAmount =
      (["below_benchmark", "above_benchmark", "below_benchmark_probation"].includes(type) &&
        config.benchmark === "A custom points target") ||
      (type === "hits_target" && config.target === "A custom points target");
    if (needsAmount) {
      const n = Number(config.amount);
      if (config.amount === undefined || config.amount === "" || Number.isNaN(n)) {
        issues.push({ target: "trigger", field: "amount", message: "Enter how many points." });
      }
    }
    if (type === "date_arrives" && !isValidDateArrives(config.date)) {
      issues.push({ target: "trigger", field: "date", message: "Enter a date like “Dec 1” or “12/1”." });
    }
  }

  draft.steps.forEach((step) => {
    if (step.disabled) return;
    const def = stepDefById(step.type);
    if (!def) return;
    const config = step.config || {};

    if (step.kind === "action" && (def.recipient || def.recipientPicker)) {
      if (def.recipientPicker && !config.recipientId) {
        issues.push({ target: step.id, field: "recipientId", message: "Pick who this notifies." });
      }
      const emptyChannels = (Array.isArray(config.channels) ? config.channels : []).filter(
        (chan) => !messageFor(config, chan)
      );
      if (emptyChannels.length) {
        issues.push({
          target: step.id,
          field: "message",
          message: `Write the ${emptyChannels.join(" and ")} message${emptyChannels.length > 1 ? "s" : ""} — it's empty.`,
        });
      }
    }

    if (step.type === "give_points" || step.type === "deduct_points") {
      const n = Number(config.amount);
      if (config.amount === undefined || config.amount === "" || Number.isNaN(n) || n <= 0) {
        issues.push({ target: step.id, field: "amount", message: "Enter how many points." });
      }
    }
  });

  return issues;
};

// Inserts {token} at the current cursor position in a text input/textarea
// (or appends it if nothing's focused yet), then restores focus and moves
// the cursor past what was just inserted. Shared by the message body and
// the email subject line — anywhere a token can go.
export const insertTokenInto = (ref, value, onChange, token) => {
  const el = ref.current;
  const text = value || "";
  const chunk = `{${token}}`;
  if (!el) {
    onChange(text + chunk);
    return;
  }
  const start = el.selectionStart ?? text.length;
  const end = el.selectionEnd ?? text.length;
  onChange(text.slice(0, start) + chunk + text.slice(end));
  requestAnimationFrame(() => {
    el.focus();
    const pos = start + chunk.length;
    el.setSelectionRange(pos, pos);
  });
};
